import * as applicationActions from 'actions/application.js'
import { mLogics } from 'utils/constants'
import { referenceParameterSchema } from 'schemas/referenceParameter'
import { rpSaveErrorHandler } from 'sagas/errorHandlers'

import { referenceParameters } from 'services'

export const SET_SP_DETAIL_LEVEL = 'SET_SP_DETAIL_LEVEL'
export function setSPDetailLevel(detailLevel, uri) {
  return {
    uri,
    detailLevel,
    type: SET_SP_DETAIL_LEVEL,
  }
}

export const GET_REFERENCE_PARAMETER = 'GET_REFERENCE_PARAMETER'
export const getReferenceParam = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.getReferenceParameter,
    args: { referenceParameterNumber, releaseNumber },
    successActionType: GET_REFERENCE_PARAMETER,
    id: `${referenceParameterNumber}/${releaseNumber}`,
    schema: referenceParameterSchema,
  })

export const GET_REFERENCE_PARAMETER_NOTES = 'GET_REFERENCE_PARAMETER_NOTES'
export const getReferenceParamNotes = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.getReferenceParameterNotes,
    args: { referenceParameterNumber, releaseNumber },
    successActionType: GET_REFERENCE_PARAMETER_NOTES,
    id: `${referenceParameterNumber}/${releaseNumber}`,
  })

export const SAVE_REFERENCE_PARAMETER_NOTES = 'SAVE_REFERENCE_PARAMETER_NOTES'
export const saveRPNotesActionStub = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  applicationActions.apiActionStub({
    asyncFn: referenceParameters.saveReferenceParamNotes,
    args: { referenceParameterNumber, releaseNumber },
    successActionType: SAVE_REFERENCE_PARAMETER_NOTES,
    id: `${referenceParameterNumber}/${releaseNumber}`,
  })

export const UPDATE_REFERENCE_PARAM_FIELD = 'UPDATE_REFERENCE_PARAM_FIELD'
export function updateReferenceParameterField(fieldName, newValue) {
  return {
    type: UPDATE_REFERENCE_PARAM_FIELD,
    fieldName,
    newValue,
  }
}

export const REFERENCE_PARAM_CLEAR_SAVE_ERRORS =
  'REFERENCE_PARAM_CLEAR_SAVE_ERROR'
export function clearSaveErrors() {
  return {
    type: REFERENCE_PARAM_CLEAR_SAVE_ERRORS,
  }
}

export const SAVE_REFERENCE_PARAM_FAILURE = 'SAVE_REFERENCE_PARAM_FAILURE'
export const SAVE_REFERENCE_PARAM = 'SAVE_REFERENCE_PARAM'
export const saveRPWithCallback = (referenceParameter, callback) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.saveReferenceParameter,
    successActionType: SAVE_REFERENCE_PARAM,
    failureActionType: SAVE_REFERENCE_PARAM_FAILURE,
    id: referenceParameter.uri,
    args: {
      referenceParameter,
      referenceParameterNumber: referenceParameter.refParameterNumber,
      releaseNumber: referenceParameter.release,
    },
    schema: referenceParameterSchema,
    resolve: callback,
    errorHandlers: [rpSaveErrorHandler],
  })

export const DUPLICATE_REFERENCE_PARAM_FAIL = 'DUPLICATE_REFERENCE_PARAM_FAIL'
export const DUPLICATE_REFERENCE_PARAM = 'DUPLICATE_REFERENCE_PARAM'
export const duplicateRP = (originalReferenceParameter) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.duplicateReferenceParameter,
    successActionType: DUPLICATE_REFERENCE_PARAM,
    failureActionType: DUPLICATE_REFERENCE_PARAM_FAIL,
    id: originalReferenceParameter.uri,
    args: { originalReferenceParameter },
    schema: referenceParameterSchema,
  })

export const EDIT_REFERENCE_PARAMETER = '@@chec/EDIT_REFERENCE_PARAMETER'
export const editReferenceParameter = (rpUrl) => ({
  type: EDIT_REFERENCE_PARAMETER,
  rpUrl,
})

export const CANCEL_REFERENCE_PARAM_EDIT = 'CANCEL_REFERENCE_PARAM_EDIT'

export const LINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM =
  'LINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM'
export const linkCurrentSPToCurrentRP = (spUri) => ({
  spUri,
  type: LINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM,
})

export const RELINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM =
  'RELINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM'
export const relinkSPToCurrentRP = (spUri) => ({
  spUri,
  type: RELINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM,
})

export const UNLINK_SUPPORT_PARAM_FROM_CURRENT_REFERENCE_PARAM =
  'UNLINK_SUPPORT_PARAM_FROM_CURRENT_REFERENCE_PARAM'
export const unlinkSPFromCurrentRP = (spUri) => ({
  spUri,
  type: UNLINK_SUPPORT_PARAM_FROM_CURRENT_REFERENCE_PARAM,
})

export const SET_COMPATIBILITY_RULES_FOR_CURRENT_RP =
  'SET_COMPATIBILITY_RULES_FOR_CURRENT_RP'
export const saveCompatibilityModules = (rules) => ({
  type: SET_COMPATIBILITY_RULES_FOR_CURRENT_RP,
  rules,
})

export const ACTIVATE_PENDING_SP_RP = 'ACTIVATE_PENDING_SP_RP'
export function activatePendingSPAndRP({
  pendingSPs,
  rpUri,
  callback,
  errorCallback,
  refParameter,
}) {
  return {
    type: ACTIVATE_PENDING_SP_RP,
    pendingSPs,
    rpUri,
    callback,
    errorCallback,
    refParameter,
  }
}

export const RP_SP_ACTIVATION_FAILURE = 'RP_SP_ACTIVATION_FAILURE'
export function activationFailSPAndRP() {
  return {
    type: RP_SP_ACTIVATION_FAILURE,
  }
}

export const SET_CURR_RP_FIELD_VALIDITY = 'SET_CURR_RP_FIELD_VALIDITY'
export const setCurrentRPValidity = (isValidForSaving, fieldName) => ({
  type: SET_CURR_RP_FIELD_VALIDITY,
  isValidForSaving,
  fieldName,
})

export const UPDATE_RP_STATUS = 'UPDATE_RP_STATUS'
export const UPDATE_RP_STATUS_FAILURE = 'UPDATE_RP_STATUS_FAILURE'
export const stubUpdateRPStatus = (uri) =>
  applicationActions.apiActionStub({
    asyncFn: referenceParameters.updateStatus,
    successActionType: UPDATE_RP_STATUS,
    failureActionType: UPDATE_RP_STATUS_FAILURE,
    id: uri,
    args: { uri },
    schema: referenceParameterSchema,
  })

export const RP_ACTIVATION_COMPLETE = 'RP_ACTIVATION_COMPLETE'

export const updateRPStatus = ({ uri, status }) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.updateStatus,
    successActionType: UPDATE_RP_STATUS,
    failureActionType: UPDATE_RP_STATUS_FAILURE,
    id: uri,
    args: { uri, status },
    schema: referenceParameterSchema,
  })

export const FETCH_SUPPORT_PARAMS_SUCCESS = 'FETCH_SUPPORT_PARAMS_SUCCESS'

export const getSupportParamsForImport = (uri) =>
  applicationActions.apiAction({
    asyncFn: referenceParameters.fetchSupportParamsForImport,
    successActionType: FETCH_SUPPORT_PARAMS_SUCCESS,
    id: uri,
    args: { uri },
    schema: referenceParameterSchema,
  })
export const RESET_RP_STATE = 'RESET_RP_STATE'
export const resetRPState = () => ({
  type: RESET_RP_STATE,
})

export const RESET_SELECTED_SOURCE_RP = 'RESET_SELECTED_SOURCE_RP'
export const resetSelectedSourceRP = () => ({
  type: RESET_SELECTED_SOURCE_RP,
})

export const SELECT_SOURCE_RP = 'SELECT_SOURCE_RP'
export const setSelectedSourceRP = (rp) => ({
  rp,
  type: SELECT_SOURCE_RP,
})

export const FETCHING_SOURCE_RP_SUPPORT_PARAMS =
  'FETCHING_SOURCE_RP_SUPPORT_PARAMS'
export const SOURCE_RP_SUPPORT_PARAMS_RECEIVED =
  'SOURCE_RP_SUPPORT_PARAMS_RECEIVED'
export const FETCHING_SOURCE_RP_SUPPORT_PARAMS_ERROR =
  'FETCHING_SOURCE_RP_SUPPORT_PARAMS_ERROR'

export const CLEAR_IMPORTABLE_SUPPORT_PARAMETERS =
  'CLEAR_IMPORTABLE_SUPPORT_PARAMETERS'
export const clearSPsForImport = () => ({
  type: CLEAR_IMPORTABLE_SUPPORT_PARAMETERS,
})

export const SET_SP_ACTION_LINK = 'SET_SP_ACTION_LINK'
export const setSPActionToLink = (uri) => ({
  uri,
  type: SET_SP_ACTION_LINK,
})

export const SET_SP_ACTION_DUPLICATE = 'SET_SP_ACTION_DUPLICATE'
export const setSPActionToDuplicate = (uri) => ({
  uri,
  type: SET_SP_ACTION_DUPLICATE,
})

export const TOGGLE_IMPORT_SP_SELECTED_STATE = 'TOGGLE_IMPORT_SP_SELECTED_STATE'
export const toggleSPSelectedState = (uri) => ({
  uri,
  type: TOGGLE_IMPORT_SP_SELECTED_STATE,
})

export const TOGGLE_ALL_IMPORT_SP_SELECTED_STATE =
  'TOGGLE_ALL_IMPORT_SP_SELECTED_STATE'
export const BATCH_IMPORT_SUPPORT_PARAMETERS = 'BATCH_IMPORT_SUPPORT_PARAMETERS'
export const BATCH_IMPORT_COMPLETE = 'BATCH_IMPORT_COMPLETE'

export const CREATE_NEW_SP = 'CREATE_NEW_SP'

export const createNewSP = (spType) => {
  if (mLogics.includes(spType)) {
    return {
      type: CREATE_NEW_SP,
      spType,
    }
  }
  return null
}

export const CLEAR_RPS = 'CLEAR_RPS'
export const GET_RPS_SUCCESS = 'GET_RPS_SUCCESS'
export const GET_RPS_FAILURE = 'GET_RPS_FAILURE'

export const getRps = (partUris, serialNumber, index) => {
  const successActionType =
    index !== undefined ? `${GET_RPS_SUCCESS}_${index}` : GET_RPS_SUCCESS
  const failureActionType =
    index !== undefined ? `${GET_RPS_FAILURE}_${index}` : GET_RPS_FAILURE
  return applicationActions.apiAction({
    asyncFn: referenceParameters.getRps,
    successActionType,
    failureActionType,
    args: { partUris, serialNumber },
  })
}
